import Representation3d from './Representation3d';
import Representation3dTypeEnum from './Representation3dTypeEnum';

import IPlacement from '../../interfaces/IPlacement3d';
import Placement3d from '../Placement3d';

import apiFbxAssetSchema from '../../services/bimVisualizerApi/schema/representation3d/apiFbxAssetSchema'


export default class FbxAsset extends Representation3d {
    
    path: string;
    placement: IPlacement;
    scaleToFit: boolean;
    isMirrored: boolean;

    constructor(path: string, placement: Placement3d, scaleToFit: boolean, isMirrored: boolean) {
        super(Representation3dTypeEnum.FbxAsset, null);
        
        this.path = path;
        this.placement = placement;
        this.scaleToFit = scaleToFit;
        this.isMirrored = isMirrored;
    }

    clone() : Representation3d {
        return new FbxAsset(this.path, this.placement.clone(), this.scaleToFit, this.isMirrored);
    }
    
    static fromJSON(json: any): Representation3d {

        const parsed = apiFbxAssetSchema.parse(json);
        return new FbxAsset(    parsed.path,
                                Placement3d.fromJSON(parsed.placement),
                                parsed.scaleToFit,
                                parsed.isMirrored);
        
    }

}